<div class="home-container">
  <div class="home-header">
    <h1>Welcome to Familitive</h1>
    <p class="subtitle">Your family connection hub</p>
  </div>

  <div class="tiles-grid">
    <!-- Activities Tile -->
    <div class="tile activities-tile" (click)="navigateToFeed()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>Activities</h3>
        <p>View family posts and updates</p>
      </div>
      <div class="badge" *ngIf="newPostsCount > 0">
        {{ newPostsCount > 99 ? '99+' : newPostsCount }}
      </div>
    </div>

    <!-- My Family Tree Tile -->
    <div class="tile family-tree-tile" (click)="navigateToFamilyTree()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 22V12H15V22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>My Family Tree</h3>
        <p>Explore your family hierarchy</p>
      </div>
    </div>

    <!-- My Timeline Tile -->
    <div class="tile timeline-tile" (click)="navigateToTimeline()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>My Timeline</h3>
        <p>View your personal timeline</p>
      </div>
    </div>

    <!-- My Family Timeline Tile -->
    <div class="tile family-timeline-tile" (click)="navigateToFamilyTimeline()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>My Family Timeline</h3>
        <p>View your family's timeline</p>
      </div>
    </div>

    <!-- Relationship Calculator Tile -->
    <div class="tile calculator-tile" (click)="navigateToRelationshipCalculator()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 11L12 14L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>Relationship Calculator</h3>
        <p>Discover family relationships</p>
      </div>
    </div>

    <!-- My Profile Tile -->
    <div class="tile profile-tile" (click)="navigateToProfile()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>My Profile</h3>
        <p>View and edit your profile</p>
      </div>
    </div>

    <!-- Invite a Relative Tile -->
    <div class="tile invite-tile" (click)="navigateToInviteRelative()">
      <div class="tile-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 11L19 13L23 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="tile-content">
        <h3>Invite a Relative</h3>
        <p>Send invitation to join your family</p>
      </div>
    </div>
  </div>
</div>

